(function () {
  'use strict';

  const STORAGE_PREFIX = 'nb-countdown-rolling:';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  // Next 00:00:00 in the visitor's local timezone, returned as ms epoch.
  function nextLocalMidnight() {
    const d = new Date();
    d.setHours(24, 0, 0, 0);
    return d.getTime();
  }

  // Resolve the deadline timestamp (ms) for a single countdown element.
  function resolveDeadline(el) {
    const mode = el.dataset.mode || 'midnight';
    if (mode === 'midnight') {
      return nextLocalMidnight();
    }
    if (mode === 'fixed') {
      const iso = el.dataset.end;
      if (!iso) return null;
      const t = Date.parse(iso);
      return isNaN(t) ? null : t;
    }
    // Rolling: store a per-section deadline in localStorage so it persists
    // for the visitor across page loads, then resets when the window closes.
    const hours = parseFloat(el.dataset.rollingHours || '24');
    const key = STORAGE_PREFIX + (el.id || hours);
    let stored = null;
    try { stored = parseInt(localStorage.getItem(key), 10); } catch (_) {}
    const now = Date.now();
    if (!stored || isNaN(stored) || stored <= now) {
      stored = now + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(stored)); } catch (_) {}
    }
    return stored;
  }

  function tick(el, deadline) {
    const digits = el.querySelector('[data-nb-countdown-digits]');
    const ended  = el.querySelector('[data-nb-countdown-ended]');
    const remainingMs = deadline - Date.now();

    if (remainingMs <= 0) {
      const mode = el.dataset.mode || 'midnight';
      if (mode === 'fixed') {
        if (digits) digits.style.display = 'none';
        if (ended)  ended.hidden = false;
        return false; // stop ticking
      }
      if (mode === 'midnight') {
        // Visitor passed local midnight while the page was open: roll to
        // tomorrow's midnight and keep counting.
        el._nbDeadline = nextLocalMidnight();
        return true;
      }
      // Rolling: reset deadline and continue.
      const hours = parseFloat(el.dataset.rollingHours || '24');
      const key = STORAGE_PREFIX + (el.id || hours);
      const next = Date.now() + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(next)); } catch (_) {}
      el._nbDeadline = next;
      return true;
    }

    const totalSec = Math.floor(remainingMs / 1000);
    const hrs  = Math.floor(totalSec / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;

    const set = (sel, v) => {
      const node = el.querySelector(sel);
      if (node) node.textContent = pad(v);
    };
    set('[data-h]', hrs);
    set('[data-m]', mins);
    set('[data-s]', secs);
    return true;
  }

  const DISMISS_KEY = 'nb-countdown-dismissed';

  function dismissedRecently() {
    try {
      const t = parseInt(localStorage.getItem(DISMISS_KEY), 10);
      // Re-show after 24h so a flash sale doesn't stay hidden forever.
      return t && (Date.now() - t) < 24 * 3600 * 1000;
    } catch (_) { return false; }
  }

  function init() {
    const els = document.querySelectorAll('[data-nb-countdown]');
    els.forEach((el) => {
      if (dismissedRecently()) {
        el.style.display = 'none';
        return;
      }
      const closeBtn = el.querySelector('[data-nb-countdown-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (_) {}
          el.style.display = 'none';
        });
      }
      const deadline = resolveDeadline(el);
      if (!deadline) return;
      el._nbDeadline = deadline;
      tick(el, el._nbDeadline);
      const interval = setInterval(() => {
        const cont = tick(el, el._nbDeadline);
        if (!cont) clearInterval(interval);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
